/**
 * ============================================
 * BLOG ARTICLE SCRIPTS
 * Enhanced FAQ accordion with dynamic content support
 * ============================================
 */

/**
 * FAQ Accordion Toggle Function
 * Opens/closes FAQ answers when questions are clicked
 */
function toggleFAQ(element) {
    const answer = element.nextElementSibling;
    const isActive = element.classList.contains('active');
    const allQuestions = document.querySelectorAll('.faq-question');
    const allAnswers = document.querySelectorAll('.faq-answer');
    
    // Close all other FAQs
    allQuestions.forEach(q => {
        if (q !== element) {
            q.classList.remove('active');
        }
    });
    allAnswers.forEach(a => {
        if (a !== answer) {
            a.classList.remove('active');
        }
    });
    
    // Toggle current FAQ
    if (!isActive) {
        element.classList.add('active');
        answer.classList.add('active');
    } else {
        // Remove active class when clicking an open accordion
        element.classList.remove('active');
        answer.classList.remove('active');
    }
}

/**
 * Initialize FAQ functionality using event delegation
 * This works even if FAQ content loads dynamically
 */
function initFAQ() {
    // Use event delegation on document body to catch all clicks
    document.body.addEventListener('click', function(e) {
        // Check if clicked element is an FAQ question or inside one
        const faqQuestion = e.target.closest('.faq-question');
        
        if (faqQuestion) {
            e.preventDefault();
            toggleFAQ(faqQuestion);
        }
    });
    
    console.log('FAQ accordion initialized with event delegation');
}

/**
 * Watch for dynamically added content
 * Detects when FAQ sections are added to the page
 */
function watchForFAQ() {
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                // Check if FAQ items were added
                const faqItems = document.querySelectorAll('.faq-item');
                if (faqItems.length > 0) {
                    console.log('FAQ section detected! Total questions:', faqItems.length);
                    
                    // Ensure all FAQ questions have pointer cursor
                    document.querySelectorAll('.faq-question').forEach(q => {
                        q.style.cursor = 'pointer';
                    });
                }
            }
        });
    });
    
    // Start observing the document body for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    console.log('FAQ mutation observer active');
}

/**
 * Set initial cursor styles for FAQ questions
 */
function setFAQStyles() {
    const faqQuestions = document.querySelectorAll('.faq-question');
    if (faqQuestions.length > 0) {
        faqQuestions.forEach(q => {
            q.style.cursor = 'pointer';
        });
        console.log('FAQ styles applied to', faqQuestions.length, 'questions');
    }
}

/**
 * Initialize everything on page load
 */
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        initFAQ();
        watchForFAQ();
        setFAQStyles();
        console.log('Blog article scripts loaded (DOMContentLoaded)');
    });
} else {
    // DOM already loaded
    initFAQ();
    watchForFAQ();
    setFAQStyles();
    console.log('Blog article scripts loaded (immediate)');
}